import * as React from 'react'

import styled, { css } from 'styled-components'

import { logout } from '@src/state/auth/actions'
import { getEmail } from '@src/state/auth/selectors'
import { getSiteConfig } from '@src/state/site/selectors'
import { BIBME, SiteState } from '@src/state/site/types'
import { RootState } from '@src/state/types'
import media from '@src/styled/media'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { UnstyledButton } from '../base/Buttons'

interface DispatchProps {
  handleLogout: () => void
}

interface StateProps {
  email?: string
  accountUrl: string
}

interface HeaderLinkProps {
  site: SiteState
}

type EmailAndLogoutProps = DispatchProps & StateProps & HeaderLinkProps

const baseHeaderCss = css<HeaderLinkProps>`
  font-weight: normal;
  color: ${({ theme, site }) =>
    site === BIBME ? theme.colors.white : theme.colors.dark};
  font-size: ${({ theme }) => theme.font.text.size.xs};
  padding-right: ${({ theme }) => theme.spacing.sm};
`
const HeaderButton = styled(UnstyledButton)<HeaderLinkProps>`
  ${baseHeaderCss}
`

const UserName = styled.span<HeaderLinkProps>`
  ${baseHeaderCss}
  ${media.phone`
    display: none; 
  `};
`

const phonePadding = css`
  padding-left: ${({ theme }) => theme.spacing.sm};
`

const BarSpacer = styled.span`
  margin: 0 ${props => props.theme.spacing.xs};
`

const Logout = styled(HeaderButton)`
  &:hover {
    cursor: pointer;
  }
  padding-left: ${({ theme }) => theme.spacing.sm};
  ${media.phone`
    padding-left: ${phonePadding};
  `};
`

const MyAccount = styled.a<HeaderLinkProps>`
  ${baseHeaderCss}
  padding-left: ${({ theme }) => theme.spacing.sm};
  text-decoration: none;
`
const EmailAndLogout: React.FunctionComponent<EmailAndLogoutProps> = ({
  email,
  handleLogout,
  site,
  accountUrl,
}) => {
  return (
    <React.Fragment>
      <UserName site={site}>Welcome, {email}</UserName>
      <BarSpacer>|</BarSpacer>
      <MyAccount href={accountUrl} site={site}>
        My Account
      </MyAccount>
      <Logout site={site} data-test="logoutNav" onClick={handleLogout}>
        Log Out
      </Logout>
    </React.Fragment>
  )
}

const mapStateToProps = (state: RootState) => ({
  email: getEmail(state),
  site: state.site,
  accountUrl: getSiteConfig(state).accountUrl,
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  handleLogout: () => dispatch(logout({ isUserAction: true })),
})

export default connect<StateProps, DispatchProps>(
  mapStateToProps,
  mapDispatchToProps
)(EmailAndLogout)



// WEBPACK FOOTER //
// ./src/components/Header/EmailAndLogout.tsx